import styled from 'styled-components';
import { theme, toRem } from 'design';

const ActionMenuListTitle = styled.span`
  display: flex;
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${toRem(24)};
  margin-bottom: ${toRem(5.5)};
  padding: 0 ${toRem(11)};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.medium};
  font-size: ${toRem(11)};
  line-height: 100%;
  color: ${theme.color.neutral[500]};
`;

export default ActionMenuListTitle;
